import { render } from "./TransportForm.vue?vue&type=template&id=2337e8d2&scoped=true"
import script from "./TransportForm.vue?vue&type=script&lang=js"
export * from "./TransportForm.vue?vue&type=script&lang=js"

import "./TransportForm.vue?vue&type=style&index=0&id=2337e8d2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2337e8d2"]])

export default __exports__